module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10243.5417fe63.jpg";